import { Box, Stack } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { tokens } from '@synergy/theme-palo';

export interface CustomerDetailConditionsFactProps {
    label: ReactNode;
    children: ReactNode;
    /** Shown greyed with a dash when there is nothing to state. */
    empty?: boolean;
}

/**
 * A value the mask states but cannot change — the SEPA mandate, the last bonus
 * paid out. These are facts from elsewhere in the system, so they are set
 * beside the fields rather than dressed up as inputs nobody can edit (#2193).
 */
export const CustomerDetailConditionsFact = ({
    label,
    children,
    empty,
}: CustomerDetailConditionsFactProps): ReactElement => (
    <Stack gap={0.5}>
        <Box
            component="span"
            sx={{
                fontSize: '10.5px',
                fontWeight: 640,
                letterSpacing: '.08em',
                textTransform: 'uppercase',
                color: tokens.color.ink3,
            }}
        >
            {label}
        </Box>
        <Box
            component="span"
            sx={{
                fontSize: '13px',
                color: empty ? tokens.color.ink3 : tokens.color.ink,
                fontVariantNumeric: 'tabular-nums',
            }}
        >
            {empty ? '–' : children}
        </Box>
    </Stack>
);
